import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import { useModal } from "../contexts/ModalContext";
import CandidatosContainer from "../Modulos/Cipa/CandidatosContainer";

const CipaCandidatos = () => {

    const { openModal } = useModal();

    const openSideBar = () => {
        openModal('sidebarCipaCandidatos');
    }

    return(
        <>
            <NavBar title="CANDIDATOS" setSideBar={ openSideBar } prevDest="./../../modulo/ssma/cipa/" />
            <GenericBody>
                <CandidatosContainer />
            </GenericBody>
        </>
    )
}

export default CipaCandidatos;